import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'find-more-events.title',
    defaultMessage: 'Find More Events',
  },
  description: {
    id: 'find-more-events.description',
    defaultMessage: 'Explore other listings and discover an event to remember.',
  },
  viewAll: {
    id: 'find-more-events.view-all',
    defaultMessage: 'View all',
  },
})
